<template>
    <div style="display: none;"></div>
</template>

<script>
import "leaflet/dist/leaflet.css";
import "leaflet-draw/dist/leaflet.draw.css";
// import "leaflet-toolbar/dist/leaflet.toolbar.css";

import 'leaflet-draw';

export default{
    props:{
        position: {
            type: String,
            default: 'bottomleft'
        },
        shapes: {
            type: Object,
            default: () => ({
                polygon: {
                    allowIntersection: false,
                    shapeOptions: {
                        color: '#bada55'
                    }
                },   
                polyline: false,
                rectangle: false,
                circle: false,
                marker: false,
                circlemarker: false
            })
        }
    },
    mounted(){
        this.$nextTick(()=>{
            const map = this.$parent.$parent.$refs.map.mapObject;

            // в leaflet вроде бы нет другого способа локализации
            // https://github.com/Leaflet/Leaflet.draw/blob/master/src/Leaflet.draw.js

            window.L.drawLocal.draw.toolbar.actions.text=this.$t('Отмена');
            window.L.drawLocal.draw.toolbar.finish.text=this.$t('Завершить');
            window.L.drawLocal.draw.toolbar.undo.text=this.$t('Убрать последнею точку');

            window.L.drawLocal.edit.toolbar.actions.cancel.text=this.$t('Отмена');
            window.L.drawLocal.edit.toolbar.actions.clearAll.text=this.$t('Очистить все');

            // Скрытие кнопок
            window.L.drawLocal.edit.toolbar.actions.save.title = 'leaflet-hide';

            // Отключение подсказок
            window.L.drawLocal.draw.handlers.polygon.tooltip.start = ''
            window.L.drawLocal.draw.handlers.polygon.tooltip.cont = ''
            window.L.drawLocal.draw.handlers.polygon.tooltip.end = ''
            window.L.drawLocal.edit.handlers.edit.tooltip.text = ''
            window.L.drawLocal.edit.handlers.edit.tooltip.subtext = ''
            window.L.drawLocal.edit.handlers.remove.tooltip.text = ''
            window.L.drawLocal.edit.handlers.remove.tooltip.subtext = ''
            

            let drawnItems = new window.L.FeatureGroup();
            map.addLayer(drawnItems);

            const drawControl = new window.L.Control.Draw({
                position: this.position,
                draw:{
                    ...this.shapes
                },
                edit: false
            })

            var drawControlEdit = new window.L.Control.Draw({
                edit: {
                    featureGroup: drawnItems
                },
                draw: false
            });

            map.addControl(drawControl);

            map.on("draw:created", function(e) {
                var layer = e.layer;
                layer.addTo(drawnItems);
                drawControl.remove(map);
                drawControlEdit.addTo(map)
            });

            map.on("draw:deleted", function() {
                drawControlEdit.remove(map);
                drawControl.addTo(map);
            });

        })
    }
}
</script>




<style>
a[title="leaflet-hide"] { 
    display: none !important; 
}

</style>